'use client'

import { twMerge } from '@/lib/classname/twMerge'
import { Icon } from '@/ui/icons/icon/Icon'
import { Button, Input, SearchField } from 'react-aria-components'
import { SELECT_FIELD_HEIGHT, SELECT_FIELD_PADDING } from '../select.styles'

type SelectSearchFieldProps = {
  placeholder: string
  'aria-label': string
  clearAriaLabel: string
}

export function SelectSearchField({
  placeholder,
  'aria-label': ariaLabel,
  clearAriaLabel,
}: SelectSearchFieldProps) {
  return (
    <SearchField
      aria-label={ariaLabel}
      autoFocus
      className="shrink-0 border-b-px border-brand-2-200"
    >
      {({ isEmpty }) => (
        <div
          className={twMerge(
            'flex w-full items-center gap-2 bg-white',
            SELECT_FIELD_HEIGHT,
            SELECT_FIELD_PADDING,
          )}
        >
          <Input
            placeholder={placeholder}
            className="h-full min-w-0 flex-1 bg-clear text-md font-medium leading-light text-brand-2-900 outline-none placeholder:text-brand-2-400 [&::-webkit-search-cancel-button]:appearance-none"
          />
          {!isEmpty && (
            <Button
              aria-label={clearAriaLabel}
              className="shrink-0 text-brand-2-500 outline-none data-[hovered]:text-brand-2-800 data-[focus-visible]:outline data-[focus-visible]:outline-2 data-[focus-visible]:outline-offset-2 data-[focus-visible]:outline-brand-1-600"
            >
              <Icon.X size="sm" />
            </Button>
          )}
          <Icon.Search size="sm" className="shrink-0 text-brand-2-900" aria-hidden />
        </div>
      )}
    </SearchField>
  )
}
